import { Controller } from "@hotwired/stimulus"

// Global slide-out cart drawer for the storefront. Lives on .themed-storefront
// so the header cart link (an ancestor-scoped action) can open it and the drawer
// markup (rendered by the layout) can be toggled. Add-to-cart streams in a fresh,
// already-open drawer (CartItemsController), so open()/close() only toggle CSS.
export default class extends Controller {
  static targets = ["overlay", "panel"]

  connect() {
    this.onKeydown = (event) => { if (event.key === "Escape") this.close() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    document.body.style.overflow = ""
  }

  open(event) {
    if (event) event.preventDefault()
    if (this.hasOverlayTarget) this.overlayTarget.classList.add("cart-drawer__overlay--open")
    if (this.hasPanelTarget) this.panelTarget.classList.add("cart-drawer__panel--open")
    document.body.style.overflow = "hidden"
  }

  close() {
    if (this.hasOverlayTarget) this.overlayTarget.classList.remove("cart-drawer__overlay--open")
    if (this.hasPanelTarget) this.panelTarget.classList.remove("cart-drawer__panel--open")
    document.body.style.overflow = ""
  }
}
